<script>
  import { flashCardModeStore } from "./stores.js";

  function toggleFlashCardMode() {
    flashCardModeStore.set({
      ...$flashCardModeStore,
      active: !$flashCardModeStore.active
    });
  }
</script>

<style>
  section {
    margin-left: 1rem;
  }

  button {
    background: var(--blue);
    border: none;
    box-shadow: var(--button-box-shadow);
    color: var(--white);
    cursor: pointer;
    display: block;
    padding: 0.5rem 1rem;
    transition: all 0.3s;
    filter: brightness(1);
  }

  button:hover {
    box-shadow: 0px 8px 9px rgba(112, 40, 45, 0.2);
    transform: translate(0, -1px);
    filter: brightness(1.065);
  }
</style>

<section>
  <button on:click={toggleFlashCardMode}>
    {$flashCardModeStore.active ? 'Show All' : 'Make Flashcards'}
  </button>
</section>
